interface IPromotionArgs {
  shopName: string;
  productName: string;
}

export const getPromotionLabel = ({ shopName, productName }: IPromotionArgs) =>
  `Ga naar ${shopName} om de aanbieding voor de ${productName} te bekijken`;
